module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "wednesday"
    }
  }, [_c('h1', [_vm._v("Wednesday")]), _vm._v(" "), _c('p', [_vm._v("It’s been five Wednesdays since the worst thing happened. People tell me I’m alive.")]), _vm._v(" "), _c('p', [_vm._v("On days when I can feel the sadness digging its nails in the corners of my eyes, I wonder")]), _vm._v(" "), _c('p', [_vm._v("if they can see your brown in the shades of my hair,")]), _vm._v(" "), _c('p', [_vm._v("if they can feel your warmth emanating from my body as they hug me to say hello,")]), _vm._v(" "), _c('p', [_vm._v("if they can see how you held me")]), _vm._v(" "), _c('p', [_vm._v("in the way I drag my body around the halls.")]), _vm._v(" "), _c('p', [_vm._v("With every passing Wednesday, I have learnt that losing you did not kill me,")]), _vm._v(" "), _c('p', [_vm._v("but no one believes me when I tell them that breathing suffocated by grief")]), _vm._v(" "), _c('p', [_vm._v("is like no breathing at all.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0